import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CustomButton from "../../../components/CustomButton";

const SpouseFilingPrompt = ({ show, onConfirm }: any) => {
  const description = "Note! If you and your spouse filed separate Federal tax returns, you will need to each file a separate return in LIME.";

  return (
    <Modal
      role="dialog"
      aria-modal="true"
      open={show}
      onClose={() => onConfirm()}
      aria-labelledby="spouse-filing-modal"
      className={'modal-container'}
    >
      <div className={'modal-paper'}>
        <Box component="p" m={1}>
          {description}
        </Box>
        <Box className={'modal-button-container'} sx={{marginTop: '1em'}}
        >
          <CustomButton
            variant="contained"
            disableElevation={false}
            label={"Got It"}
            onClick={() => onConfirm()}
          />
        </Box>
      </div>
    </Modal>
  );
};

export default SpouseFilingPrompt;
